import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { FaEye } from "react-icons/fa";
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const Ven_Ladger_Product_Details_List = () => {
    const token = localStorage.getItem('token');
    const navigate = useNavigate();
    const [data, setVendorDataDetails] = useState([]);
    const [depositamt, setDeposit] = useState([]);
    const [withdrawamt, setWithdraw] = useState([]);
    const [TotalLagerAmt, setTotalLagerAmt] = useState([]);
    const ven_ladger_id = localStorage.getItem('ven_ladger_id');
    const ven_costomer_id = localStorage.getItem('ven_det_costomer_id');

    useEffect(() => {
        fetchVendorDetails();
    }, [token]);

    const fetchVendorDetails = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Vendor-payments-data-lists/${ven_ladger_id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            const otherData = response.data.data || [];
            setVendorDataDetails(otherData);
            setDeposit(response.data.totalMgfProductAmount);
            setWithdraw(response.data.totalSumPrice);
            setTotalLagerAmt(response.data.TotalLagerAmt);
        } catch (error) {
            console.error('Error fetching vendors:', error);
        }
    };
    return (
        <>
            <div className="App">
                <div className="card">
                    <div className="card-header">
                        <div className="d-flex">
                            <div><Link to='/vendor-ladgor' className='btn-added'>Back</Link></div>
                        </div>
                    </div>
                    <div className="card-body" >
                        <div style={{ minHeight: '50vh', maxHeight: '400px', overflowY: 'auto' }}>
                            <table className='table table-striped hover border'>
                                <thead className='thead-dark' style={{
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 3,
                                    backgroundColor: 'black',
                                    color: 'white',
                                }}>
                                    <tr>
                                        {/* <th>Sr.no</th> */}
                                        <th>Date</th>
                                        <th>Product Category</th>
                                        <th>Customer Name</th>
                                        <th>Customer Site Name</th>
                                        <th>Account Name</th>
                                        <th>Mode</th>
                                        <th>Withdraw(Dr)</th>
                                        <th>Deposit(Cr)</th>
                                        <th>Closing Balanace</th>

                                    </tr>
                                </thead>
                                <tbody className='trcolorchange'>
                                    {data && data.map((vendor, index) => (
                                        <tr key={vendor.vendor_id}>
                                            {/* <td>{index + 1}</td> */}
                                            <td>
                                                {vendor.amount
                                                    ? vendor.payment_date && !isNaN(new Date(vendor.payment_date).getTime())
                                                        ? new Date(vendor.payment_date).toLocaleDateString('en-GB', {
                                                            year: 'numeric',
                                                            month: 'numeric',
                                                            day: 'numeric',
                                                        })
                                                        : ''
                                                    : vendor.date && !isNaN(new Date(vendor.date).getTime())
                                                        ? new Date(vendor.date).toLocaleDateString('en-GB', {
                                                            year: 'numeric',
                                                            month: 'numeric',
                                                            day: 'numeric',
                                                        })
                                                        : ''
                                                }
                                            </td>
                                            {/* <td>{vendor.product_name}</td> */}
                                            <td>{vendor.amount
                                                ? vendor.category_name || 'NA'
                                                : vendor.name || 'NA'
                                            }</td>
                                            {/* <td>{vendor.category_name || 'NA'}</td> */}
                                            <td>{vendor.customer_name || 'NA'}</td>
                                            <td>{vendor.site_name || 'NA'}</td>
                                            <td>{vendor.account_name || 'NA'}</td>
                                            <td>{vendor.mode || 'NA'}</td>
                                            <td style={{ color: 'red' }}>{vendor.total_price || '-'}</td>
                                            <td style={{ color: 'green' }}>{vendor.amount || '-'}</td>
                                            <td>-</td>
                                        </tr>
                                    ))}
                                </tbody>

                                <tfoot>
                                    <tr style={{
                                        position: 'sticky',
                                        bottom: 0,
                                        zIndex: 3,
                                        backgroundColor: 'black',
                                        color: 'white',
                                        borderTop: "none",
                                    }}>
                                        <td colSpan="6" style={{ textAlign: 'right', fontWeight: 'bold' }}></td>
                                        <td style={{ color: 'red', fontWeight: 'bold' }}>
                                            DR {withdrawamt}
                                        </td>
                                        <td style={{ color: 'green', fontWeight: 'bold' }}>
                                            CR {depositamt}
                                        </td>
                                        <td
                                            style={{
                                                color: TotalLagerAmt < 0 ? 'red' : 'green',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {TotalLagerAmt}
                                        </td>

                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                    </div>
                    <div className="bg-white p-3">
                        <h6>STATEMENT SUMMARY</h6>
                        <hr></hr>
                        <div className='d-flex justify-content-between'>
                            <p>Total Debits: {withdrawamt}</p>
                            <p>Total Credits: {depositamt}</p>
                            <p>Closing Balance: {TotalLagerAmt} </p>
                        </div>
                        <hr></hr>
                    </div>

                </div>



            </div>
        </>
    );
};

export default Ven_Ladger_Product_Details_List;
